'use strict';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { EaselPlugin } from 'gsap/EaselPlugin';
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

export const initScrollAnimation = () => {
  const targets = document.querySelectorAll('.js-scroll-animation');
  targets.forEach((target) => {
    ScrollTrigger.create({
      trigger: target,
      start: 'top 70%',
      once: true,
      onEnter: () => {
        target.classList.add('is-active');
      },
    });
  });
};
